import React, { useState } from 'react'
import styles from './ModalAddServiceInstallation.module.css'
import PropTypes from 'prop-types'
import { t } from 'i18next'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import No from 'Assets/Images/Login/no.svg'
import drillIcon from 'Assets/Images/Generals/drill.svg'
import { NO_INSTALLATION_OPTION } from 'Utils/constants'
import { CustomDropdownSelector } from 'Components/ServiceCard/CustomDropdownSelector'
import { useInstallationServices } from 'Hooks/useInstallationServices'
import { addOrIncrementServiceInCart } from 'Utils/Helpers/cartInstallationHelpers'

const ModalAddServiceInstallation = ({
  show,
  onClose,
  services = [],
  installationService,
}) => {
  const dispatch = useDispatch()

  // Local state
  const [isApplying, setIsApplying] = useState(false)

  const {
    servicesData,
    selectedServices,
    rawSelected,
    selectService,
    removeService,
    cart,
    resetSelection,
  } = useInstallationServices(services, { syncWithCart: false })

  const handleApply = async () => {
    setIsApplying(true)
    for (const s of rawSelected) {
      await addOrIncrementServiceInCart(dispatch, cart, s)
    }

    resetSelection()
    setIsApplying(false)
    handleClose()
  }

  const handleToggleService = item => {
    const isAlreadySelected = rawSelected.some(
      s => s.productId === item.productId
    )

    if (isAlreadySelected) {
      removeService(item.productId)
    } else {
      selectService(item)
    }
  }

  const handleClose = () => {
    resetSelection()
    onClose()
  }

  const effectiveSelectedServices =
    selectedServices.length === 0 ? [NO_INSTALLATION_OPTION] : selectedServices

  return (
    <Modal
      centered
      show={show}
      backdrop="static"
      className={styles.modalAddServiceInstallation}
      data-testid="modal-add-service-installation">
      <div
        className={styles.modalContent}
        data-testid="container-modal-service-content">
        <div
          className={styles.containerTitleService}
          data-testid="container-service-title">
          <button
            onClick={handleClose}
            className={styles.closeButton}
            data-testid="btn-close-service-modal">
            <img src={No} alt="close" data-testid="img-close-service-modal" />
          </button>
          <img
            src={drillIcon}
            alt="installation icon"
            className={styles.iconServiceInstallation}
            data-testid="img-installation-icon"
          />
          <h3 className={styles.titleService} data-testid="text-service-title">
            {t('INSTALLATION_SERVICE_T.INSTALLATION_SERVICE')}
          </h3>
        </div>
        <div
          className={styles.serviceDetailsContainer}
          data-testid="container-service-details">
          <p
            className={styles.serviceDetails}
            data-testid="text-service-description">
            {t('INSTALLATION_SERVICE_T.INSTALLATION_SERVICE_DESCRIPTION', {
              sku: installationService?.productSku,
            })}
          </p>
          <CustomDropdownSelector
            label={NO_INSTALLATION_OPTION.name}
            value={effectiveSelectedServices}
            options={servicesData}
            onSelect={handleToggleService}
            getOptionLabel={item => item.name}
            getOptionValue={item => item.productId}
            name="services-selector"
            unselectableOption={NO_INSTALLATION_OPTION}
          />
          <div
            className={styles.buttonContainer}
            data-testid="container-service-buttons">
            <button
              className={styles.cancelButton}
              onClick={handleClose}
              data-testid="btn-cancel-service">
              {t('Cancel')}
            </button>
            <button
              className={styles.applyButton}
              onClick={handleApply}
              data-testid="btn-apply-service">
              {isApplying ? (
                <CircularProgress
                  size={20}
                  color="inherit"
                  data-testid="spinner-applying-service"
                />
              ) : (
                t('Apply')
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAddServiceInstallation

ModalAddServiceInstallation.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  services: PropTypes.arrayOf(PropTypes.object).isRequired,
  installationService: PropTypes.object,
}
